/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import Section from "../../../components/common/Section";
import Input from "../../../components/Input";
import { OrderFormData, SHIPMENT_SERVICE_OPTIONS, PAYMENT_TYPE_OPTIONS, ORDER_SHIPMENT_TYPE_OPTIONS, LocationState } from "../../../types/types";
import { FieldErrors, UseFormClearErrors, UseFormHandleSubmit, UseFormRegister, UseFormSetValue } from "react-hook-form";
import SelectInput from "../../../components/Select";
import { useDistrictFetchData, useFetchCountriesAllData, useFetchCountryCitiesAllData } from "../../../apis/locationApis";
import TextareaField from "../../../components/common/TextareaField";


type Props = {
  open: boolean;
  onClose: () => void;
  order: any;
  register: UseFormRegister<OrderFormData>;
  errors: FieldErrors<OrderFormData>;
  setValue: UseFormSetValue<OrderFormData>;
  watch: any;
  clearErrors: UseFormClearErrors<OrderFormData>;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>; // Changed this line
  isPending: boolean;
  // onSubmit: (data: OrderFormData) => void; // Added this line
};

const EditOrderModal = ({
  open,
  onClose,
  order,
  register,
  errors,
  setValue,
  watch,
  clearErrors,
  handleSubmit,
  isPending
  // onSubmit
}: Props) => {
  const [editMode, setEditMode] = useState(false);

  // API data
  const { data: countries = [] } = useFetchCountriesAllData();
  const { data: senderCities = [], refetch: fetchSenderCities } =
    useFetchCountryCitiesAllData(watch('sender.country'));
  const { data: senderDistricts = [], refetch: fetchSenderDistricts } =
    useDistrictFetchData(watch('sender.city'));
  const { data: receiverCities = [], refetch: fetchReceiverCities } =
    useFetchCountryCitiesAllData(watch('receiver.country'));
  const { data: receiverDistricts = [], refetch: fetchReceiverDistricts } =
    useDistrictFetchData(watch('receiver.city'));

  useEffect(() => {
    if (order?.receiverCountry) {
      fetchReceiverCities()
    }
  }, [order?.receiverCountry])

  useEffect(() => {
    if (order?.receiverCity) {
      fetchReceiverDistricts()
    }
  }, [order?.receiverCity])

  useEffect(() => {
    if (order?.senderCountry) {
      fetchSenderCities()
    }
  }, [order?.senderCountry])

  useEffect(() => {
    if (order?.senderCity) {
      fetchSenderDistricts()
    }
  }, [order?.senderCity])

  useEffect(() => {
    if (order) {
      setValue('sender.name', order?.senderName);
      setValue('sender.mobile', order?.senderMobile);
      setValue('sender.email', order?.senderEmail);
      setValue('sender.country', order?.senderCountry);
      setValue('sender.city', order?.senderCity);
      setValue('sender.district', order?.senderDistrict);
      setValue('sender.zipCode', order?.senderZipCode);
      setValue('sender.latitude', order?.senderLatitude);
      setValue('sender.longitude', order?.senderLongitude);
      setValue('sender.address', order?.senderAddress);
      setValue('sender.nationalAddress', order?.senderNationalAddress);
      setValue('receiver.name', order?.receiverName);
      setValue('receiver.mobile', order?.receiverMobile);
      setValue('receiver.email', order?.receiverEmail);
      setValue('receiver.country', order?.receiverCountry);
      setValue('receiver.city', order?.receiverCity);
      setValue('receiver.district', order?.receiverDistrict);
      setValue('receiver.zipCode', order?.receiverZipCode);
      setValue('receiver.latitude', order?.receiverLatitude);
      setValue('receiver.longitude', order?.receiverLongitude);
      setValue('receiver.address', order?.receiverAddress);
      setValue('receiver.nationalAddress', order?.receiverNationalAddress);
      setValue('shipment.paymentType', order?.paymentType);
      setValue('shipment.codAmount', order?.codAmount);
      setValue('shipment.numberOfPieces', order?.noOfPieces);
      setValue('shipment.totalWeight', order?.totalWeight);
    }
  }, [order]);

  if (!open) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center p-6">
      <div className=" bg-[#F7F6F2] rounded-2xl [@media(min-width:1920px)]:w-9/12 [@media(min-width:1536px)]:w-12/12 mx-auto ">
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
          <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2]">
            <h1 className="text-xl">AWB No. {order?.awbNumber}</h1>
            <button
              onClick={() => {
                if (editMode) setEditMode(false);
                else onClose();
              }}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
            >
              <IconX size={20} />
            </button>
          </div>
          <div className="  max-h-[90vh] overflow-y-auto  px-4 py-4 ">
            <div className="grid grid-cols-2 gap-4">
              {/* Sender */}
              <div className="bg-[#FFFFFF] p-4 rounded-xl">
                <Section title={"SENDER INFORMATION"}>
                  <div className="space-y-2 text-sm pt-4">
                    {/* <div className="flex items-center gap-3 w-full">
                    <label
                      htmlFor=""
                      className="flex-shrink-0 text-[#1E293B] text-sm"
                    >
                      Select Client
                    </label>
                    <input
                      value="Priya Verma"
                      className="px-4 py-2 text-sm w-full rounded-full outline-none bg-white border border-[#D8D8D8]"
                      placeholder="Name"
                    />
                  </div> */}
                    <div className="flex items-center gap-3 w-full">
                      <Input
                        name="sender.name"
                        type="text"
                        title="Name"
                        register={register}
                        error={errors.sender?.name}
                        validation={{ required: "Sender name is required" }}
                        className="flex items-center w-full gap-2"
                      />
                    </div>
                    <div className="flex gap-2">
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="sender.mobile"
                          type="number"
                          title="Mobile"
                          register={register}
                          error={errors.sender?.mobile}
                          validation={{ required: "Sender mobile is required" }}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="sender.email"
                          type="text"
                          title="Email"
                          register={register}
                          error={errors.sender?.email}
                          validation={{ required: "Sender email is required" }}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <div className="flex items-center gap-3 w-full">
                        <SelectInput
                          name="sender.country"
                          className="flex items-center w-full gap-2"
                          label="Country"
                          placeholder="Select Country"
                          selectOptions={countries?.map((country: any) => ({
                            id: country.id,
                            value: country.id,
                            text: country.name,
                          }))}
                          register={register}
                          clearErrors={clearErrors}
                          validation={{ required: "Sender country is required" }}
                          disabled={!countries?.length}
                          value={watch('sender.country')}
                          setValue={(val: string) => {
                            const country = countries.find((c: any) => c.id === val);
                            // Handle receiver country change if needed
                            setValue('sender.country', val);
                            setValue('sender.countryName', country?.name || '');
                            setValue('sender.city', '');
                            setValue('sender.cityName', '');
                            setValue('sender.district', '');
                            setValue('sender.districtName', '');
                          }}
                        />
                      </div>

                      <div className="flex items-center gap-3 w-full">
                        <SelectInput
                          name="sender.city"
                          label="City"
                          className="flex items-center w-full gap-2"
                          placeholder="Select City"
                          selectOptions={senderCities.map((city: any) => ({
                            id: city.id,
                            value: city.id,
                            text: city.name,
                          }))}
                          clearErrors={clearErrors}
                          register={register}
                          validation={{ required: "Sender city is required" }}
                          disabled={!senderCities.length}
                          value={watch('sender.city')}
                          setValue={(val: string) => {
                            const city = senderCities?.find((c: any) => c.id === val);
                            setValue('sender.city', val);
                            setValue('sender.cityName', city?.name || '');
                            setValue('sender.district', '');
                            setValue('sender.districtName', '');
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <div className="flex items-center gap-3 w-full">
                        <SelectInput
                          name="sender.district"
                          label="District"
                          className="flex items-center w-full gap-2"
                          placeholder="Select District"
                          selectOptions={senderDistricts.map((district: any) => ({
                            id: district.id,
                            value: district.id,
                            text: district.name,
                          }))}
                          clearErrors={clearErrors}
                          register={register}
                          validation={{ required: "Sender district is required" }}
                          disabled={!senderDistricts.length}
                          value={watch('sender.district')}
                          setValue={(val: string) => {
                            const district = senderDistricts?.find((c: any) => c.id === val);
                            setValue('sender.district', val);
                            setValue('sender.districtName', district?.name  || '');
                          }}
                        />
                      </div>
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="sender.zipCode"
                          type="number"
                          title="Zip Code"
                          register={register}
                          error={errors.sender?.zipCode}
                          validation={{ required: "Sender zipcode is required" }}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-3 w-full">
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="sender.latitude"
                          type="number"
                          title="Latitude"
                          step="any"
                          inputMode="decimal"
                          register={register}
                          error={errors.sender?.latitude}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="sender.longitude"
                          type="number"
                          title="Longitude"
                          step="any"
                          inputMode="decimal"
                          register={register}
                          error={errors.sender?.longitude}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                    </div>
                    <div className="flex items-center gap-3 w-full">
                      <TextareaField
                        rows={2}
                        className="flex items-center w-full gap-2"
                        label="Address"
                        register={register}
                        name="sender.address"
                        placeholder=""
                        error={errors.sender?.address}
                        validation={{ required: "Sender address is required" }}
                      />
                    </div>
                    <div className="flex items-center gap-3 w-full">
                      <TextareaField
                        rows={2}
                        className="flex items-center w-full gap-2"
                        label="National Address"
                        register={register}
                        placeholder=""
                        name="sender.nationalAddress"
                        error={errors.sender?.nationalAddress}
                        validation={{ required: "Sender national address is required" }}
                      />
                    </div>
                  </div>
                </Section>
              </div>

              {/* Receiver */}
              <div className="bg-[#FFFFFF] p-4 rounded-xl">
                <Section title={"RECEIVER INFORMATION"}>
                  <div className="space-y-2 text-sm pt-4">
                    <div className="flex items-center gap-3 w-full">
                      <Input
                        name="receiver.name"
                        type="text"
                        title="Name"
                        register={register}
                        error={errors.receiver?.name}
                        validation={{ required: "Receiver name is required" }}
                        className="flex items-center w-full gap-2"
                      />
                    </div>
                    <div className="flex gap-2">
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="receiver.mobile"
                          type="number"
                          title="Mobile"
                          register={register}
                          error={errors.receiver?.mobile}
                          validation={{ required: "Receiver mobile is required" }}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="receiver.email"
                          type="text"
                          title="Email"
                          register={register}
                          error={errors.receiver?.email}
                          validation={{ required: "Receiver email is required" }}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <div className="flex items-center gap-3 w-full">
                        <SelectInput
                          name="receiver.country"
                          className="flex items-center w-full gap-2"
                          label="Country"
                          placeholder="Select Country"
                          selectOptions={countries.map((country: any) => ({
                            id: country.id,
                            value: country.id,
                            text: country.name,
                          }))}
                          register={register}
                          clearErrors={clearErrors}
                          validation={{ required: 'Receiver country is required' }}
                          disabled={!countries.length}
                          value={watch('receiver.country')}
                          setValue={(val: string) => {
                            const country = countries.find((c: any) => c.id === val);
                            // Handle receiver country change if needed
                            setValue('receiver.country', val);
                            setValue('receiver.countryName', country?.name || '');
                            setValue('receiver.city', '');
                            setValue('receiver.cityName', '');
                            setValue('receiver.district', '');
                            setValue('receiver.districtName', '');
                          }}
                        />
                      </div>
                      <div className="flex items-center gap-3 w-full">
                        <SelectInput
                          name="receiver.city"
                          label="City"
                          className="flex items-center w-full gap-2"
                          placeholder="Select City"
                          selectOptions={receiverCities.map((city: any) => ({
                            id: city.id,
                            value: city.id,
                            text: city.name,
                          }))}
                          clearErrors={clearErrors}
                          register={register}
                          validation={{ required: 'Receiver city is required' }}
                          disabled={!receiverCities.length}
                          value={watch('receiver.city')}
                          setValue={(val: string) => {
                            const city = receiverCities?.find((c: any) => c.id === val);
                            setValue('receiver.city', val);
                            setValue('receiver.cityName', city?.name || '');
                            setValue('receiver.district', '');
                            setValue('receiver.districtName', '');
                          }}
                        />
                      </div>
                    </div>

                    <div className="flex gap-2">
                      <div className="flex items-center gap-3 w-full">
                        <SelectInput
                          name="receiver.district"
                          className="flex items-center w-full gap-2"
                          label="District"
                          placeholder="Select District"
                          selectOptions={receiverDistricts?.map((district: any) => ({
                            id: district?.id,
                            value: district?.id,
                            text: district?.name,
                          }))}
                          register={register}
                          clearErrors={clearErrors}
                          validation={{ required: 'Receiver district is required' }}
                          disabled={!receiverDistricts?.length}
                          value={watch('receiver.district')}
                          setValue={(val: string) => {
                            const district = receiverDistricts?.find((c: any) => c.id === val);
                            setValue('receiver.district', val);
                            setValue('receiver.districtName', district?.name  || '');
                          }}
                        />
                      </div>
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="receiver.zipCode"
                          type="text"
                          title="Zip Code"
                          register={register}
                          error={errors.receiver?.zipCode}
                          validation={{ required: 'Zip code is required' }}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                    </div>

                    <div className="flex gap-2">
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="receiver.latitude"
                          type="number"
                          title="Latitude"
                          step="any"
                          inputMode="decimal"
                          register={register}
                          error={errors.receiver?.latitude}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                      <div className="flex items-center gap-3 w-full">
                        <Input
                          name="receiver.longitude"
                          type="number"
                          title="Longitude"
                          step="any"
                          inputMode="decimal"
                          register={register}
                          error={errors.receiver?.longitude}
                          className="flex items-center w-full gap-2"
                        />
                      </div>
                    </div>
                    <div className="flex items-center gap-3 w-full">
                      <TextareaField
                        rows={2}
                        className="flex items-center w-full gap-2"
                        label="Address"
                        register={register}
                        name="receiver.address"
                        placeholder=""
                        error={errors.receiver?.address}
                        validation={{ required: "Receiver address is required" }}
                      />
                    </div>
                    <div className="flex items-center gap-3 w-full">
                      <TextareaField
                        rows={2}
                        className="flex items-center w-full gap-2"
                        label="National Address"
                        register={register}
                        placeholder=""
                        name="receiver.nationalAddress"
                        error={errors.receiver?.nationalAddress}
                        validation={{ required: "Receiver national address is required" }}
                      />
                    </div>
                  </div>
                </Section>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-4 mt-6 text-sm">
              <div className="flex items-center gap-3 w-full">
                <SelectInput
                  name="shipment.paymentType"
                  label="Payment Type"
                  className="flex items-center w-full gap-2"
                  placeholder="Select Payment Type"
                  selectOptions={PAYMENT_TYPE_OPTIONS}
                  clearErrors={clearErrors}
                  register={register}
                  value={watch('shipment.paymentType')}
                  setValue={(val: string) => {
                    setValue('shipment.paymentType', val);
                    if (val !== 'COD') {
                      setValue('shipment.codAmount', '');
                    }
                  }}
                  validation={{ required: "Payment Type is required" }}
                />
              </div>

              {watch('shipment.paymentType') === 'COD' && (
                <div className="flex items-center gap-3 w-full">
                  <Input
                    name="shipment.codAmount"
                    type="number"
                    title="COD Amount"
                    register={register}
                    value={watch('shipment.codAmount')}
                    error={errors.shipment?.codAmount}
                    validation={{ required: "COD amount is required" }}
                    className="flex items-center w-full gap-2"
                  />
                </div>
              )}

              <div className="flex items-center gap-3 w-full">
                <Input
                  name="shipment.numberOfPieces"
                  type="number"
                  title="No of Pieces"
                  register={register}
                  error={errors.shipment?.numberOfPieces}
                  value={watch('shipment.numberOfPieces')}
                  validation={{
                    required: "No of pieces is required",
                    min: { value: 1, message: "Must be at least 1" }
                  }}
                  className="flex items-center w-full gap-2"
                />
              </div>

              <div className="flex items-center gap-3 w-full">
                <Input
                  name="shipment.totalWeight"
                  type="text"
                  title="Total Weight (kg)"
                  register={register}
                  error={errors.shipment?.totalWeight}
                  value={watch('shipment.totalWeight')}
                  validation={{
                    required: "Total weight is required",
                    pattern: {
                      value: /^\d*\.?\d*$/,
                      message: "Must be a valid number"
                    }
                  }}
                  className="flex items-center w-full gap-2"
                />
              </div>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="border-t border-[#D8D8D8] px-4 py-4 flex justify-end space-x-2">
            <button
              className="border border-[#D8D8D8] bg-transparent flex items-center rounded-full p-2 px-4 space-x-1 cursor-pointer text-base font-medium"
              onClick={() => {
                if (editMode) setEditMode(false);
                else onClose();
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className={`border ${
                isPending
                  ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
                  : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
              } flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium`}
            >
              Update
              {isPending && (
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                  />
                </svg>
              )}
            </button>
          </div>
        {/* </form> */}
      </div>
    </div>
  );
};

export default EditOrderModal;